/**
 * 正负双指标求和条形图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const positiveAndNegativeDoubleIndicatorSumBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: ['string', 'date'], required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'y2', type: 'number', required: true }
  ],
  businessRules: [
    {
      name: 'positive-negative-double-indicator-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 2,
      message:
        'Positive and negative double indicator sum bar chart requires at least 2 data points',
      suggestion: 'Provide at least 2 data points for meaningful comparison between indicators',
      severity: 'warning'
    },
    {
      name: 'positive-negative-double-indicator-value-variation',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const yValues = data.map(item => Number(item[encoding?.y as string]));
        const y2Values = data.map(item => Number(item[encoding?.y2 as string]));

        const hasPositiveY = yValues.some(val => val > 0);
        const hasNegativeY = yValues.some(val => val < 0);
        const hasPositiveY2 = y2Values.some(val => val > 0);
        const hasNegativeY2 = y2Values.some(val => val < 0);

        return (hasPositiveY || hasNegativeY) && (hasPositiveY2 || hasNegativeY2);
      },
      message:
        'Positive and negative double indicator chart works best with varied positive/negative values',
      suggestion:
        'Include both positive and negative values in y and y2 fields to show indicator contrast',
      severity: 'warning'
    },
    {
      name: 'positive-negative-double-indicator-meaningful-difference',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        return data.some(item => {
          const yVal = Number(item[encoding?.y as string]);
          const y2Val = Number(item[encoding?.y2 as string]);
          return Math.abs(yVal - y2Val) > 0;
        });
      },
      message: 'Double indicator chart requires meaningful differences between y and y2 values',
      suggestion:
        'Ensure y and y2 fields have different values to show indicator comparison effectively',
      severity: 'warning'
    }
  ]
};
